import { combineReducers } from 'redux'
import web3Reducer from '../modules/web3/reducer'
import stakingReducer from '../modules/staking/reducer'
import poolReducer from '../modules/pool/reducer'
import dropReducer from '../modules/drop/slice'
import memecoinsReducer from '../modules/memecoins/slice'
import seasonsReducer from '../modules/seasons/slice'
import listPools from '../modules/listPools/reducer'
import listDrops from '../modules/listDrops/reducer'
import miscUI from '../modules/miscUi/reducer'
import accessReducer from '../modules/access/reducer'
import missionControlReducer from '../modules/missionControl/slice'
import userReducer from '../modules/user/slice'
import fromQuestionsReduces from '../modules/formQuestion/slice'
import { apiSlice } from '../api/slice'

const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  web3: web3Reducer,
  staking: stakingReducer,
  listPool: listPools,
  listDrop: listDrops,
  pool: poolReducer,
  drop: dropReducer,
  access: accessReducer,
  miscUI,
  missionControl: missionControlReducer,
  user: userReducer,
  formQuestions: fromQuestionsReduces,
  memecoins: memecoinsReducer,
  seasons: seasonsReducer,
})

export default rootReducer
